import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEGRADE = "linear-gradient(90deg, var(--temp-1), var(--temp-2), var(--temp-3), var(--temp-4), var(--temp-5), var(--temp-6), var(--temp-7))";

export function useMesVues(ecran) {
  const [data, setData] = useState(null);
  const [vue, setVue] = useState(null);
  useEffect(() => { api.get("/vues/moi", { params: { ecran } }).then((r) => { setData(r.data); setVue(r.data.defaut); }).catch(() => setData({ vues: [], defaut: null })); }, [ecran]);
  return { vues: data?.vues || [], charge: Boolean(data), vue, setVue };
}

export function useStats(pid) {
  const [stats, setStats] = useState(null);
  const charger = useCallback(() => { if (pid) api.get(`/processus/${pid}/statistiques`).then((r) => setStats(r.data)); }, [pid]);
  useEffect(() => { charger(); }, [charger]);
  return { stats, recharger: charger };
}

const Pill = ({ actif, onClick, testId, children }) => (
  <button type="button" onClick={onClick} data-testid={testId} className={`at-chip ${actif ? "actif" : ""}`}>{children}</button>
);

export const VuesOnglets = ({ vues, vue, setVue, testId = "view-tabs" }) => vues.length > 1 && (
  <div className="flex gap-2 overflow-x-auto no-scrollbar mb-4" data-testid={testId}>
    {vues.map((v) => <Pill key={v.code} actif={v.code === vue} onClick={() => setVue(v.code)} testId={`${testId}-${v.code}`}>{v.nom}</Pill>)}
  </div>
);

export const ProcessusPills = ({ processus, pid, setPid, testId = "pipeline-process" }) => (
  <div className="flex gap-2 overflow-x-auto no-scrollbar mb-4">
    {processus.map((p) => <Pill key={p.id} actif={p.id === pid} onClick={() => setPid(p.id)} testId={`${testId}-${p.id}`}>{p.nom}</Pill>)}
  </div>
);
